<template>
	<core-layout-headline-with-tabs :tabs="tabs">
		{{ $t("quote") }}
	</core-layout-headline-with-tabs>
</template>

<script>
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"

export default {
	components: { CoreLayoutHeadlineWithTabs },

	computed: {
		tabs() {
			const possibleFields = [
				{
					id: "overview",
					name: this.$t("overview"),
					to: { name: "QuoteDetail", params: { ...this.$route.params } }
				},
				{
					name: this.$t("offers"),
					to: {
						name: "OffersList",
						params: { ...this.$route.params }
					}
				},
				{
					name: this.$t("transactions"),
					to: {
						name: "QuoteTransactions",
						params: { ...this.$route.params }
					}
				},
				{
					name: this.$t("logs"),
					to: {
						name: "QuoteLogs",
						params: { id: this.$route.params.id }
					}
				}
			]

			return possibleFields
		}
	}
}
</script>
